import { useFormContext, useWatch } from 'react-hook-form';
import { useEffect } from 'react';
import { CurrencyInputV2, DocumentNumberFieldV2, FormFieldV2 } from '@/components/custom/erp';
import { FormFieldActions, FormFieldState } from '../../hooks';
import { Label } from '@/components/ui/label';
import { MA_CHUNG_TU } from '@/constants';
import { FormMode } from '@/types/form';

interface BasicInfoTabProps {
  formMode: FormMode;
  formState: {
    state: FormFieldState;
    actions: FormFieldActions;
  };
}

export function BasicInfoTab({ formMode, formState: { state, actions } }: BasicInfoTabProps) {
  const { setValue } = useFormContext();
  const ngay_ct = useWatch({ name: 'ngay_ct' });

  useEffect(() => {
    if (ngay_ct) {
      setValue('ngay_lct', ngay_ct);
    }
  }, [ngay_ct, setValue]);

  return (
    <div className='flex p-4'>
      {/* Tab Content */}
      <div className='flex w-full justify-between'>
        <div className='w-full'>
          <div className='flex items-center'>
            <DocumentNumberFieldV2
              ma_ct={MA_CHUNG_TU.MUA_HANG.CHUNG_TU_PHAI_TRA_KHAC}
              quyenChungTu={state.quyenChungTu}
              onQuyenChungTuChange={actions.setQuyenChungTu}
              soChungTu={state.soChungTu}
              onSoChungTuChange={actions.setSoChungTu}
              disabled={formMode === 'view'}
              classNameSearchField='ml-3 w-fit'
              formMode={formMode}
            />
          </div>
          <FormFieldV2
            label='Ngày chứng từ'
            name='ngay_ct'
            type='date'
            disabled={formMode === 'view'}
            labelClassName='w-32 shrink-0'
            className='w-fit'
          />
          <FormFieldV2
            label='Ngày lập chứng từ'
            name='ngay_lct'
            type='date'
            disabled={formMode === 'view'}
            labelClassName='w-32 shrink-0'
            className='w-fit'
          />
          <FormFieldV2
            label='Diễn giải'
            name='dien_giai'
            type='text'
            disabled={formMode === 'view'}
            labelClassName='w-32 shrink-0'
            fieldClassName='w-full'
          />
        </div>
        <div className='w-3/8'>
          <CurrencyInputV2 formMode={formMode} />
          <FormFieldV2
            label='Trạng thái'
            name='status'
            type='select'
            disabled={formMode === 'view'}
            labelClassName='w-32 shrink-0'
            className='w-full'
            options={[
              { value: '0', label: 'Chưa ghi sổ' },
              { value: '3', label: 'Chờ duyệt' },
              { value: '5', label: 'Đã ghi sổ' }
            ]}
          />
          <div className='mt-4 flex items-center'>
            <FormFieldV2 name='transfer_yn' type='checkbox' disabled={formMode === 'view'} className='ml-12' />
            <Label className='w-32 shrink-0'>Dữ liệu được nhận</Label>
          </div>
        </div>
      </div>
    </div>
  );
}
